import { EventBus as _EventBus } from '@streaming/mouflon-utils';

import { TDoppioEvents } from './IEventBus';

export class EventBus<TEvents> extends _EventBus<TEvents> {}
export type TEventBus = EventBus<TDoppioEvents>;
